import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import GroupedDataSource from '~/Api/DataSource/GroupedDataSource';
import { updatedSelectedTypes } from '~/ProductSearchableDataSource';
import { ApplicationState, ThunkDispatch } from '~/Store';

import ProductFilterForm from './ProductFilterForm';

import type { DatasetPresence, PricesPresence } from '~/Api/Product';

function mapStateToProps(state: ApplicationState): {
	availableParameters: ApplicationState['products']['availableParameters'];
	groupedDataSources: GroupedDataSource[] | null;
	selectedGrouppingType: string | null;
	pricesPresence: PricesPresence | null;
	datasetPresence: DatasetPresence | null;
} {
	return {
		availableParameters: state.products.availableParameters,
		groupedDataSources: state.productSearchableDataSource.groupedDataSources,
		selectedGrouppingType: state.productSearchableDataSource.selectedGrouppingType,
		pricesPresence: state.productSearchableDataSource.pricesPresence,
		datasetPresence: state.productSearchableDataSource.datasetPresence,
	};
}

function mapDispatchToProps(dispatch: ThunkDispatch<AnyAction>): {
	onSubmitSearchDataSourceSettings: (params: {
		types: Set<string> | null;
		selectedGrouppingType: string | null;
		groupName: string | null;
		pricesPresence: PricesPresence | null;
		datasetPresence: DatasetPresence | null;
	}) => void;
} {
	return {
		onSubmitSearchDataSourceSettings: (params: {
			types: Set<string> | null;
			selectedGrouppingType: string | null;
			groupName: string | null;
			pricesPresence: PricesPresence | null;
			datasetPresence: DatasetPresence | null;
		}) => {
			dispatch(updatedSelectedTypes(params));
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductFilterForm);
